import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import './css/CatInfo.css';
import CatAvatar from '../components/img/avatars/CatAvatar.png';

const CatInfo = () => {
  const { unique_id } = useParams();
  const [cat, setCat] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchCatInfo = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/cat/info/${unique_id}/`);
        setCat(response.data);
        setNotFound(false); // Reset not found state if cat is found
      } catch (error) {
        console.error('Error fetching cat info:', error);
        setNotFound(true); // Set not found state if error occurs
      }
    };

    fetchCatInfo();
  }, [unique_id]);

  if (notFound) {
    return (
      <div className="cat-info-container">
        <h1>404</h1>
        <p>未找到此猫咪的信息</p>
      </div>
    );
  }

  if (!cat) return <div>Loading...</div>;

  return (
    <div className="cat-info-container">
      <h1>猫咪信息</h1>
      <div className="cat-info-card">
        <div className="center-horizontal">
          <img src={cat.photos[0] ? cat.photos[0] : CatAvatar} className="avatar" alt={cat.name} />
        </div>
        <div className="cat-info-details">
          <p><strong>名字:</strong> {cat.name}</p>
          <p><strong>品种:</strong> {cat.breed ? `${cat.breed.name_cn} (${cat.breed.name_en})` : 'Unknown'}</p>
          <p><strong>出生日期:</strong> {cat.birth_date}</p>
          <p><strong>唯一ID:</strong> {cat.unique_id}</p>
          <p><strong>性别:</strong> {cat.sex === 'M' ? '公猫' : '母猫'}</p>
          <p><strong>出生城市:</strong> {cat.birth_city}</p>
        </div>
      </div>
    </div>
  );
};

export default CatInfo;
